<div class="header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  @if (allowNew) {
    <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
      <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
    </button>
  }
</div>
<div class="header d-flex d-md-none align-items-center">
  <h1 class="w-100">{{ title | translate }}</h1>
  @if (allowNew) {
    <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
      <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
    </button>
  }
</div>
<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
@if (itemsSource) {
  <app-paged-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [itemsSource]="itemsSource"
    [menuDefinition]="menuDefinition"
    [totalCount]="totalResults"
    [preferencesKey]="'rent.parking-contract.list'"
    (onPageChange)="pagingChanged($event)"
    (onSortChange)="sortChanged($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    >
  </app-paged-list-view>
}
